<template>
  <div>
    <EventTab
      :items="items"
      :columns="columns"
      :captionTab = "captiontable"
      :isCalled="false"
      :selectedValue="selectedItem"
      @editItem="showEditDialog"
      v-model="selectedItem"
      :captionSpr="captionSport"
      :urls="urls"
      ref="EventTab"
    >
    </EventTab>

    <b-modal ref="editModal" v-model="modalEditOpened" title="Редактирование статуса мероприятия" size="lg" hide-footer
             id="editModal">
      <div class="d-block">
        <label class="mb-1">Наименование</label>
        <b-form-invalid-feedback :state="validValue.fio">Указано пустое наименование</b-form-invalid-feedback>
        <b-form-input class="mb-2" type="text" placeholder="Укажите наименование" v-model="selectedItem.nameKind"/>
      </div>
      <div class="d-block">
        <label class="mb-1">Описание</label>
        <b-form-input class="mb-2" type="text" placeholder="Укажите описание" v-model="selectedItem.descriptionKind"/>
      </div>
      <b-button class="mt-3" variant="outline-primary" block @click="saveKind">Сохранить</b-button>
      <b-button class="mt-3" variant="outline-danger" block @click="modalEditOpened=!modalEditOpened">Отменить

      </b-button>
    </b-modal>

  </div>
</template>

<script>
  import EventTab from '@/components/TabSpr.vue'
  import http from '@/http-common'

  export default {
    name: 'EventKind',
    components: {EventTab},
    data() {
      return {
          captiontable:'Статус мероприятий',
        items: [],
        editItem: {},
        urls: {
          save: '/eventkind/save',
          delete: '/eventkind',
        },
        captionSport: {
          name: 'Статус мероприятий',
          nameR: 'статус мероприятия'
        },
        columns: [
          {key: 'nameKind', label: 'Наименование'},
          {key: 'descriptionKind', label: 'Описание'},
          {key: 'edit_field', label: ''}
        ],
        selectedItem: {id: 0},
        modalEditOpened: false,
        validValue: {
          name: true,
          form: true,
        }
      }
    },
    created() {
      this.loadItems();
    },
    methods: {
      checkForm() {
        for (var key in this.validValue) {
          this.validValue[key] = true;
        }
        if (!this.selectedItem.nameKind || this.selectedItem.nameKind == '') {
          this.validValue.name = false;
          this.validValue.form = false;
        }
      },
      loadItems() {
        var vm = this;
        http.get('/eventkind/list')
          .then((response) => {
            vm.items = response.data;
          })
          .catch((error) => console.log(error.response.data));
      },
      showEditDialog() {
        this.modalEditOpened = !this.modalEditOpened;
      },
      saveKind() {
        this.checkForm();
        if (this.validValue.form) {
          this.modalEditOpened = false;
          this.$refs.EventTab.save(this.selectedItem);
        }
      }
    }
  }
</script>
